import RichTextButton from './RichTextButton';

export default RichTextButton;
